import * as React from 'react';
import {CardGroup} from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import {resolveWidget} from './utils';
import {Action, Help} from '../../system/buttons';
import {PremiumFeatureDescription} from '../../system/FeatureDescriptionModal';
import {groupByThree} from '../../system/utils';
import {WidgetPreviewContainer} from '../../system/WidgetPreviewContainer/WidgetPreviewContainer';

const firstPart = [
  'ordinary',
  'faithful',
  'clever',
  'agile',
  'squeaky',
  'savvy',
  'wild',
  'fearless',
  'colored',
  'big',
  'annoying',
  'fast',
  'talking',
  'tenacious',
  'invisible',
  'suspicious',
  'cute',
  'sleepy',
  'lazy',
  'powerful',
  'strong',
  'white',
  'marvelous',
  'brilliant',
  'sly',
  'friendly',
  'protected',
  'soft',
];

const secondPart = [
  'cat',
  'dog',
  'rat',
  'raven',
  'derret',
  'cavy',
  'pig',
  'wolf',
  'honey badger',
  'mantis shrimp',
  'whale',
  'cougar',
  'cheetah',
  'parrot',
  'koala',
  'bat',
  'raccoon',
  'wombat',
  'panda',
  'sloth',
  'monitor_lizard',
  'python',
  'chinchilla',
  'platypus',
  'chimpanzee',
  'fox',
  'bear',
  'battleship',
  'alpaca',
];

const generateName = () => {
  let first = firstPart[Math.floor(Math.random() * firstPart.length)];
  let second = secondPart[Math.floor(Math.random() * secondPart.length)];
  return `${first}_${second}`;
};

const EmptyCard = () => {
  return (
    <Card
      style={{
        width: '18rem',
        height: '16rem',
        margin: '5px',
        border: '1px solid white',
      }}
      className="text-center"
      key={new Date().toISOString() + Math.random()}
    ></Card>
  );
};

export const WidgetCard = ({
  predefinedWidget,
  heartRate,
  addNewWidget,
  showHeader = true,
  addButtonText = 'Add to my widgets',
}) => {
  let widget = resolveWidget(
    predefinedWidget.configuration,
    predefinedWidget.metaId,
    predefinedWidget.predefinedWidgetId,
    heartRate
  );

  return (
    <WidgetPreviewContainer
      id={predefinedWidget.metaId}
      title={predefinedWidget.description}
      header={
        showHeader ? (
          predefinedWidget.premium ? (
            <>
              BRO plan 🌟 <PremiumFeatureDescription />
            </>
          ) : (
            'Free'
          )
        ) : null
      }
      actions={
        <Action
          onClick={() => addNewWidget(predefinedWidget.id, generateName())}
        >
          {addButtonText}
        </Action>
      }
    >
      {widget}
    </WidgetPreviewContainer>
  );
};

const extractTags = (predefinedWidgets) => {
  let tags = [];
  let keys = {};
  predefinedWidgets
    .map((widget) => widget.tags)
    .flat()
    .forEach((tag) => {
      if (keys[tag.key]) {
      } else {
        tags.push(tag);
        keys[tag.key] = true;
      }
    });
  return tags;
};
export const MarketPlace = ({
  history,
  addNewWidget,
  predefinedWidgets,
  heartRate,
}) => {
  const tags = extractTags(predefinedWidgets);
  const currentTag = resolveCurrentTag(
    history,
    tags.map((tag) => tag.key)
  );

  return (
    <div>
      {predefinedWidgets && (
        <>
          <TagLine tags={tags} history={history} currentTag={currentTag} />
          {groupByThree(
            predefinedWidgets
              .filter((widget) =>
                widget.tags.map((tag) => tag.key).includes(currentTag)
              )
              .map((widget, index) => (
                <WidgetCard
                  key={index}
                  predefinedWidget={widget}
                  heartRate={heartRate}
                  addNewWidget={addNewWidget}
                />
              )),
            (index) => <EmptyCard key={index} />
          ).map((group, index) => (
            <CardGroup key={index}>{group}</CardGroup>
          ))}
        </>
      )}
    </div>
  );
};

const resolveCurrentTag = (history, tags) => {
  let params = new URLSearchParams(history.location.search);
  let candidate = params.get('tag') ? params.get('tag') : 'all';
  return tags.includes(candidate) ? candidate : 'all';
};

const TagLine = ({tags, history, currentTag}) => {
  return (
    <div className={'p-1'}>
      {tags.map((tag, index) => {
        if (currentTag === tag.key) {
          return (
            <Action
              className={'mr-1 mb-1'}
              key={index}
              onClick={() => {
                history.push({
                  search: `?tag=${tag.key}`,
                });
              }}
            >
              {tag.displayName}
            </Action>
          );
        } else {
          return (
            <Help
              className={'mr-1 mb-1'}
              key={index}
              onClick={() => {
                history.push({
                  search: `?tag=${tag.key}`,
                });
              }}
            >
              {tag.displayName}
            </Help>
          );
        }
      })}
    </div>
  );
};
